import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { SimpleFormSelect } from "src/app/components/form/SimpleFormSelect";
import { useMessageTagsOptions } from "src/app/hooks";
import { MessageTransport } from "src/app/transports/Message";
import { Message, TTagType, UpsertMessage } from "src/app/types/Message";
import { object, string } from "yup";

export interface IAddTagsModalContainer {
    selectedRows: Message[];
    handlerValueToUpdateGrid(update: boolean): void;
    handleClose(): void;
    showModal: boolean;
}
const AddTagsModalContainer = (props: IAddTagsModalContainer) => {
    const { selectedRows, handlerValueToUpdateGrid, handleClose, showModal } = props;

    const { formatMessage } = useIntl();
    const { tagsOptions } = useMessageTagsOptions();

    const [loading, setLoading] = useState(false);

    const onSubmit = async (_values: { tags: Array<string> | undefined }) => {
        const valuesToSubmit = selectedRows.map((row) => ({
            ...MessageTransport.formTransformer(row),
            ..._values,
        }));
        setLoading(true);
        try {
            await MessageTransport.saveBulk(valuesToSubmit as Array<UpsertMessage>);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handlerValueToUpdateGrid(true);
            handleClose();
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName="Tag"
            showModal={showModal}
            handleClose={handleClose}
            formId="addTag"
            loading={loading}
            modalProps={{ size: "sm" }}
        >
            <Formik
                initialValues={{ tags: undefined }}
                validationSchema={object().shape({
                    tags: string<TTagType>(),
                })}
                onSubmit={onSubmit}
            >
                <Form id="addTag">
                    <SimpleFormSelect
                        name="tag"
                        values={tagsOptions}
                        tagPlaceholder={formatMessage({
                            id: "common.field.placeholder.tag",
                        })}
                    />
                </Form>
            </Formik>
        </SimpleModal>
    );
};

export default AddTagsModalContainer;
